export default __webpack_public_path__ + "static/media/USTaxl.b4ca3c52.png";